<template>
  <div class="page">
    <navigation>选择银行卡</navigation>

    <!-- 已绑银行卡列表 -->
    <section class="section">
      <div class="card-list">
        <bankcard
          v-for="(item, index) in bankcardList"
          :key="index"
          :data="item"
          :showSwitch="showSwitch(item)"
          class="card-item"
          @change="change"
          @click="choose(item)"
        >
        </bankcard>
      </div>

      <button
        class="button"
        @click="add"
        v-if="bankcardList.length < 5"
      >
        + 添加银行卡
      </button>

      <div class="instruction" v-if="allShowSwitch()">
        <p>1、您最多可绑定5张银行卡</p>
        <p>
          2、代扣银行卡默认为首次添加的收款卡，您也可通过“勾选”选择其他银行卡
        </p>
      </div>
    </section>
  </div>
</template>
<script>
import Bankcard from './components/bankcard'
import { mapState, mapActions, mapMutations } from 'vuex'
import { isEmptyObject, isTMDMiniprogram } from '@/assets/utils'
import wx from 'weixin-webview-jssdk'

export default {
  name: 'bankcard-list',

  description: '银行卡列表',

  customReadyNotify: true,

  components: {
    Bankcard
  },
  data () {
    return {
      position: this.$route.query.position, // 埋点需要，判断来源
      termId: this.$route.query.termId,
      loanPlatform: this.$route.query.loanPlatform,
      fundCode: this.$route.query.fundCode,
      orderId: this.$route.query.orderId,
      isWxMiniProgramRepay: this.$route.query.isWxMiniProgramRepay// 小程序中H5还款流程进入卡列表
    }
  },

  async created () {
    await this.getBankcardList()
    this.$bus.$emit('ready')
  },

  computed: {
    ...mapState('bankcard', {
      bankcardList: state => state.bankcardList
    })
  },

  beforeRouteLeave (to, from, next) {
    if (to.name === 'withdrawIndex' && !isEmptyObject(to.query)) {
      next('/withdraw/index')
    } else {
      next()
    }
  },

  methods: {
    ...mapActions('bankcard', ['getBankcardListX']),
    ...mapMutations('bankcard', ['setSelectedBankcard']),

    showSwitch (item) {
      return !!this.termId && item.defaultChange
    },

    allShowSwitch () {
      if (this.bankcardList?.length === 0) {
        return true
      }
      for (let index = 0; index < this.bankcardList?.length; index++) {
        const element = this.bankcardList[index]
        if (element.defaultChange) {
          return true
        }
      }
      return false
    },

    async getBankcardList () {
      const res = await this.getBankcardListX({
        loanPlatform: this.loanPlatform,
        fundCode: this.fundCode,
        termId: this.termId,
        orderId: this.orderId
      })
      return res
    },

    add () {
      this.$report({
        id: 10107
      })
      this.$router.push({
        path: '/bankcard/add',
        query: {
          position: this.position,
          loanPlatform: this.loanPlatform,
          fundCode: this.fundCode,
          orderId: this.$route.query.orderId,
          // 放心呗和颜值贷都不能修改手机号
          canChangePhoneNo: ['YZD', 'FXB'].includes(this.loanPlatform) ? 'false' : 'true',
          isWxMiniprogramListToAdd: isTMDMiniprogram() ? 'Y' : ''
        }
      })
    },

    change () {
      this.getBankcardList()
    },

    choose (item) {
      if (isTMDMiniprogram()) {
        // 还款流程和预授信补充资料都在用这个参数
        if (this.isWxMiniProgramRepay === 'Y') {
          // 微信小程序H5还款流程
          this.setSelectedBankcard(item)
          this.$router.go(-1)
        } else {
          // 微信小程序 需要传递给小程序
          wx.miniProgram.postMessage({ data: { eventType: 'BANK_LIST_ITEM', eventId: '', url: '', value: JSON.stringify(item) } })
          wx.miniProgram.navigateBack()
        }
      } else {
        this.setSelectedBankcard(item)
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
    background-color: #fafafa;
    .section {
        padding: 0 40px;
        overflow: hidden;
        .card-list {
            .card-item {
                margin: 30px auto;
            }
        }

        .button {
            display: block;
            width: 100%;
            height: 110px;
            line-height: 110px;
            background: rgba(255, 255, 255, 1);
            border-radius: 14px;
            border: 1px solid rgba(235, 235, 235, 1);
            font-size: 32px;
            font-weight: 400;
            color: rgba(255, 70, 51, 1);
        }

        .instruction {
            margin-top: 150px;
            margin-bottom: 77px;
            font-size: 28px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 40px;
        }
    }
}
</style>
